var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("calculator-input-range", {
    attrs: {
      label: _vm.label,
      required: _vm.required,
      tooltip: _vm.tooltip,
      "side-tag": _vm.sideTag,
      min: _vm.min,
      max: _vm.max,
      value: _vm.sanitizedValue,
      errorShow: _vm.errorShow,
      errorText: _vm.errorText,
      mask: _vm.mask,
      numSteps: _vm.numSteps,
      logScale: _vm.logScale,
      parseMaskedValue: _vm.parseMaskedValue,
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }